import React from 'react';
import { clients, testimonials } from '../../data/mock';

const ClientsSection = () => {
  return (
    <section id="clients" className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1F33] via-[#0F2942] to-[#0B1F33]"></div>
      
      {/* Subtle background image - Abstract blue */}
      <div className="absolute inset-0 opacity-[0.03]">
        <img 
          src="https://images.unsplash.com/photo-1557682250-33bd709cbe85?q=80&w=2829&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#1F7A8C]/30 to-transparent"></div>
      <div className="absolute top-1/3 right-0 w-64 h-64 bg-[#1F7A8C]/10 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute bottom-1/4 left-0 w-80 h-80 bg-[#3B82F6]/5 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="flex items-center gap-4 mb-4">
          <div className="w-14 h-0.5 bg-[#5BB5C5] rounded"></div>
          <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-widest">Client Experience</p>
        </div>
        <h2 className="text-[#5BB5C5] font-semibold text-2xl lg:text-3xl mb-4 max-w-2xl">
          Clients We Have Served
        </h2>
        <p className="text-[#B8C8D8] text-lg mb-12 max-w-3xl">
          <span className="text-[#E8B86D]">IJSS IT Solutions</span> has delivered <span className="text-[#5BB5C5]">SAP MDG</span> engagements for enterprises, 
          system integrators, and advisory firms across diverse industries and geographies.
        </p>

        {/* Client Logos Grid */}
        <div className="mb-16">
          <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-wider mb-6">
            Our Esteemed Clients
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {clients.map((client, index) => (
              <div key={index} className="client-logo-card">
                <img 
                  src={client.logo} 
                  alt={client.name}
                  className="client-logo"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <span className="text-[#A8B8C8] text-sm font-medium hidden text-center">
                  {client.name}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials */}
        <div className="mb-12">
          <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-wider mb-6">
            Client Testimonials
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <p className="text-[#A8B8C8] mb-4 italic relative z-10">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-2">
                  <div className="w-1 h-4 bg-gradient-to-b from-[#1F7A8C] to-[#5BB5C5] rounded"></div>
                  <p className="text-[#5BB5C5] font-semibold text-sm">
                    {testimonial.company}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Disclaimer */}
        <div className="bg-gradient-to-r from-[rgba(91,181,197,0.1)] to-[rgba(91,181,197,0.05)] border-l-4 border-[#5BB5C5] p-5 rounded-r-lg">
          <p className="text-[#8899AA] text-sm">
            Engagements delivered directly and through SAP partners. 
            Client references available upon request subject to confidentiality agreements.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
